import React from 'react';

export function CloseButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Close product details"
      style={{
        position: 'absolute',
        top: 16,
        right: 16,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        padding: 0,
        border: '1px solid #DCDDDC',
        borderRadius: 100,
        background: '#ffffff',
        cursor: 'pointer',
        transition: 'background-color 150ms ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#F5F5F5';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = '#ffffff';
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.06127 7.00013L12.7801 2.28108C13.0733 1.98814 13.0733 1.51283 12.7801 1.21989C12.4869 0.926703 12.0122 0.926703 11.719 1.21989L7.00013 5.93894L2.28103 1.21989C1.98785 0.926703 1.51307 0.926703 1.21989 1.21989C0.926705 1.51283 0.926705 1.98814 1.21989 2.28108L5.93899 7.00013L1.21989 11.7192C0.926705 12.0121 0.926705 12.4874 1.21989 12.7804C1.36648 12.9267 1.55859 13 1.75046 13C1.94232 13 2.13444 12.9267 2.28103 12.7801L7.00013 8.06106L11.719 12.7801C11.8656 12.9267 12.0577 13 12.2496 13C12.4414 13 12.6335 12.9267 12.7801 12.7801C13.0733 12.4872 13.0733 12.0119 12.7801 11.7189L8.06127 7.00013Z"
          fill="#031425"
        />
      </svg>
    </button>
  );
}
